import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from '../commons/session.service';
import { CartService } from '../commons/cart.service';
import { ConfiguratorApiService } from '../commons/configurator-api.service';
import { TranslateService } from '../commons/translate.service';

@Component({
  selector: 'mybtnToggle',
  template: `
    <li class="btnToggle {{ this.visibility() }} {{ this.isEnabled() }} {{this.isParameter()}}" (click)="changeState($event)">

      <span class="number">{{this.number}}</span>

      <a title="{{this.sort}} {{this.text}} {{this.url}}">

          {{this.text | translate | async}}

          <div class="nameproduct">
            <div *ngFor="let v of this.getBtnDesc()">{{ v ? (v | translate | async) : '' }} </div>
          </div>

          <i class="fa fa-angle-right big"></i>
      </a>

    </li>

  `
})


export class BtnToggleComponent {

  @Input() text = 'testo';
  @Input() url: string;
  @Input() sort: number;
  @Input() number: number;
  @Input() parameter: boolean;
  @Output() clickBtn = new EventEmitter();

  constructor(
    private router: Router,
    private session: SessionService,
    private cartService: CartService,
    public configApi: ConfiguratorApiService,
    private translate: TranslateService
  ) { }


  getBtnDesc() {
    //console.log(this.text);
    if (this.number === 1) {
      return [this.session.productConfig.name];
    }
    else if (this.text === 'NavbarFormato') {
      return [
        this.cartService.cart.currentCartProduct.format ?
          this.cartService.cart.currentCartProduct.format.split('|')[1].split('_').join('')
          : null,
        this.session.orientamento
      ];
    }
    else if (this.parameter) {
      let prms = this.session.params
        .filter(p => p.table === this.text && p.reportTable === 'Navbar' && p.type !== 'Hidden')
        .sort((p1, p2) => p2.sort - p1.sort)
        .reverse()
        .map(p => p.selectedValue.replace('F_', '').replace('_x_', ' x '));


      return prms;
      // if (!prms || prms.length === 0) {
      //   return [''];
      // } else {
      //   return [ prms[0].selectedValue ];
      // }
    }

    return [];
  }

  visibility() {
    let thisParam = this.session.params.filter(p => p.table === this.text && p.reportTable === 'Navbar')[0];
    let isDisabled = '';
    if (thisParam) {
      if (this.parameter && thisParam.type === 'Hidden' && thisParam.table !== 'NavbarFormato') {
        isDisabled = ' hidden';
      }
    }

    if (this.router.isActive('/' + this.url, true)) {
      return 'active' + isDisabled;
    } else {
      return 'inactive' + isDisabled;
    }
  }

  public isEnabled() {

    let stateEnabled = 'enabled'; // 'disabled';
    if (this.url === 'select-products' || this.url === 'upload-photo') {
      stateEnabled = 'enabled';
    }

    if (this.cartService.cart.currentCartProduct != null) {
      if (this.url === 'slide-parameter/Formato') {
        if (this.cartService.cart.currentCartProduct.photoOriginal != null) {
          stateEnabled = 'enabled';
        }
      } else if (this.url === 'preview') {
        if (this.cartService.cart.currentCartProduct.photoResized != null) {
          stateEnabled = 'enabled';
        }
      }
    }

    return stateEnabled;
  }

  public isParameter() {
    if (this.parameter === true) {
      return 'isparameter';
    } else { return null; }
  }

  public changeState() {
    if (this.isEnabled() === 'enabled') {
      this.clickBtn.emit(this);
    }
  }



}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/btnToggle.component.ts